/*
 * @Author: Ryan
 * @Date: 2026-01-09
 * @Description: Footer CTA Section for Video Translator landing page
 */
import { useRouter } from 'next/router';
import React, { useContext } from 'react';

import StartButton from '@/3.0/ai-avatar-generator/seo/StartButton';
import { RightContext } from '@/components/RightProvider/context';
import { VIDEO_TRANSLATOR_URL } from '@/landing/video-translator/config';

import styles from './index.module.scss';

export interface FooterCTASectionProps {
  /** 区块标题 */
  title: string;
  /** 区块描述 */
  subtitle: string;
  /** CTA 按钮文本 */
  ctaText: string;
}

const FooterCTASection: React.FC<FooterCTASectionProps> = ({
  title,
  subtitle,
  ctaText,
}) => {
  const router = useRouter();
  const rightContext = useContext(RightContext);

  // CTA 点击
  const handleCtaClick = async () => {
    if (!rightContext.getIsLoggedIn()) {
      await rightContext.getUserLoginState({
        onReady: () => {
          router.push(VIDEO_TRANSLATOR_URL);
        },
      });
      return;
    }
    router.push(VIDEO_TRANSLATOR_URL);
  };

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* 标题 */}
        <h2 className={styles.title}>{title}</h2>

        {/* 描述 */}
        <p className={styles.subtitle}>{subtitle}</p>

        {/* CTA 按钮 */}
        <div className={styles.ctaWrapper}>
          <StartButton
            text={ctaText}
            onClick={handleCtaClick}
            className={styles.ctaButton}
          />
        </div>
      </div>
    </section>
  );
};

export default FooterCTASection;
